export const SALES_API_BASE_URL = "/sales-api";

export const SIGNALS_API_BASE_URL = `${SALES_API_BASE_URL}/api-signals`;
